export default __webpack_public_path__ + "static/media/lolly@3x.ad424891.png";